import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../../constants/api';
import { decodeToken, getToken } from '../../../utils/TokenUtils';
import axios from 'axios';

const IncomeStatement = ({report,link,value}) => {
  // State to store income data fetched from the API
  const [incomeData, setIncomeData] = useState([]);
  const [loading, setLoading] = useState(true); // To show loading state
  const [error, setError] = useState(null); // For handling errors
  const token = getToken();
  const companyBanner = decodeToken(token, 'banner');
  console.log(companyBanner);
  // Get the current date
  const currentDate = new Date().toLocaleDateString();

  // Company name (You can replace this with your actual company name)
  const companyName = decodeToken(token, 'companyName');
  // Fetch data from the API on component mount
  useEffect(() => {
   setIncomeData(report);
        setLoading(false); 
  }, [report]); // Empty array means it runs once on component mount

  // Render a loading message while fetching
  if (loading) {
    return <div>Loading...</div>;
  }

  // Handle errors
  if (error) {
    return <div>{error}</div>;
  }

  // Helper function to remove dollar sign and convert to number
  const parseAmount = (amount) => {
    if (typeof amount === 'string') {
      return parseFloat(amount.replace(/[^0-9.-]+/g, '')); // Remove any non-numeric characters
    }
    return amount;
  };

  // Group the data by AccountType
  const revenueData = incomeData.filter(
    (item) => item.AccountType === 'Main' || item.AccountType === 'SubRevenue'
  );
  const expenseData = incomeData.filter(
    (item) => item.AccountType === 'Main' || item.AccountType === 'SubExpense'
  );

  // Calculate TotalRevenue and TotalExpense
  const totalRevenue = revenueData.reduce((total, item) => {
    return total + (parseAmount(item.Amount) || 0); // Summing up the revenue amounts without dollar sign
  }, 0);

  const totalExpense = expenseData.reduce((total, item) => {
    return total + (parseAmount(item.Amount) || 0); // Summing up the expense amounts without dollar sign
  }, 0);

  // Calculate Profit/Loss
  const profitLoss = totalRevenue - totalExpense;

  // Helper function to format amounts with dollar sign
  const formatAmount = (amount) => {
    return `$${amount.toLocaleString()}`; // Adding $ sign back when displaying the amount
  };

  return (
    <div style={styles.container}>
      {/* Company Name and Date Section */}
      <div style={styles.headerSection}>
        <header style={styles.bannerHeader}>
          <img
            src={`${API_URL}/${companyBanner}`}
            alt="Company Banner"
            style={styles.logo}
          />
        </header>
        <h1 style={styles.companyName}>{companyName}</h1>
        <p style={styles.date}>Income Statement as of {currentDate}</p>
      </div>
      <table style={styles.table}>
        {/* <thead>
          <tr>
            <th style={styles.header}>Account</th>
            <th style={styles.header}>Amount ($)</th>
          </tr>
        </thead> */}
        <tbody>
          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Revenue
            </td>
          </tr>
          {revenueData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubRevenue' ? styles.subAccountRow : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubRevenue'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item.Amount))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Revenue</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalRevenue)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Expenses
            </td>
          </tr>
          {expenseData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubExpense' ? styles.subAccountRow : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubExpense'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item.Amount))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Expense</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalExpense)}
            </td>
          </tr>

          {/* Add the Profit/Loss row */}
          <tr>
            <td style={styles.totalLabel}>
              {profitLoss >= 0 ? 'Net Profit' : 'Net Loss'}
            </td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(profitLoss)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    width: '80%',
    margin: 'auto',
    // paddingTop: '20px',
  },
  headerSection: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  bannerHeader: {
    textAlign: 'center',
    marginBottom: '20px',
  },

  logo: {
    width: '100%',
    height: '150px',
  },
  companyName: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  date: {
    fontSize: '16px',
    color: '#555',
  },
  title: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  table: {
    width: '100%',
    // borderCollapse: 'collapse',
  },
  header: {
    // backgroundColor: '#f4f4f4',
    padding: '0px',
    textAlign: 'left',
    // border: '1px solid #ddd',
  },
  rowLabel: {
    padding: '0px',
    border: '1px solid #ddd',
  },
  rowAmount: {
    padding: '0px',
    // border: '1px solid #ddd',
    textAlign: 'right',
  },
  mainAccount: {
    padding: '0px',
    // backgroundColor: '#e0e0e0',
    fontWeight: 'bold',
    textAlign: 'left',
    // border: '1px solid #ddd',
  },
  subAccountRow: {
    // backgroundColor: '#f9f9f9',
  },
  subAccountLabel: {
    paddingLeft: '24px', // Indent for sub-accounts
    padding: '0px',
    //border: '1px solid #ddd',
  },
  totalLabel: {
    fontWeight: 'bold',
    padding: '0px',
    //  backgroundColor: '#d3d3d3',
    textAlign: 'left',
    //  border: '1px solid #ddd',
  },
};

export default IncomeStatement;
